import { useState } from 'react';
import { maskDecimal } from '@givebutter/util';
import * as Select from 'components/select';
import { useCurrencySymbol } from 'customHooks/useCurrencySymbol';
import useDebounce from 'customHooks/useDebounce';
import { useInfiniteTransactions } from 'customHooks/useInfiniteTransactions';
import { dateFromServer } from 'helpers/dates';
import { Transaction } from 'types/domain';

type SelectTransactionFormProps = {
    onSelectItem?: (item: Select.SelectItem<Transaction>) => void;
};

const SelectTransaction = (props: SelectTransactionFormProps) => {
    const [search, setSearch] = useState('');
    const debouncedSearch = useDebounce(search);
    const currency = useCurrencySymbol();

    const { data, ref } = useInfiniteTransactions(
        {
            query: debouncedSearch,
            without: 'pledges',
        },
        {
            staleTime: Infinity,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
        },
    );
    const transactions = data?.pages ?? [];

    return (
        <Select.SearchableSelect
            localSearch={false}
            clearable={true}
            inputProps={{
                placeholder: 'Search existing transactions',
                onChange: e => {
                    setSearch(e.currentTarget.value);
                },
            }}
            onSelectItem={value => {
                if (!value) {
                    setSearch('');
                    return;
                }
                props.onSelectItem?.(value as Select.SelectItem<Transaction>);
            }}
            multi={false}
        >
            {!transactions.length && <div className="p-2 text-gray-500">No transactions found</div>}
            {transactions.map(item => (
                <Select.ListItem
                    key={item.id}
                    value={{
                        id: item.id.toString(),
                        label: `#${item.number}`,
                        value: item,
                    }}
                >
                    <div className="flex w-full items-center justify-between">
                        <div>
                            <p className="font-medium">
                                {`${currency}${maskDecimal(item.amount ?? 0)}`}
                            </p>
                            <p className={'text-sm text-gray-600'}>
                                {item.first_name} {item.last_name} -{' '}
                                {item?.transacted_at
                                    ? dateFromServer(item.transacted_at).toFormat('LLL dd, yyyy')
                                    : ''}
                            </p>
                        </div>
                        <p className={'text-sm text-gray-600'}>#{item.number}</p>
                    </div>
                </Select.ListItem>
            ))}
            <div ref={ref} />
        </Select.SearchableSelect>
    );
};

export { SelectTransaction };
